import React, { memo } from 'react'
import { TextField } from '@ecommerce/shared'
import { InputWrapper, SaveButton, ErrorMessage } from './styled'

interface CustomizableInputProps {
  className?: string
  value: string
  error?: string
  isSaved: boolean
  isDisabled: boolean
  placeholder: string
  ariaLabel: string
  name: string
  onChange: (value: string) => void
  onSave: () => void
}

const CustomizableInput = ({
  className,
  value,
  error,
  isSaved,
  isDisabled,
  placeholder,
  ariaLabel,
  name,
  onChange,
  onSave,
}: CustomizableInputProps) => {
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange(e.target.value)
  }

  const handleKeyPress = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      e.preventDefault()
      e.stopPropagation()
    }
  }

  return (
    <InputWrapper hasError={!!error} className={className}>
      <TextField
        value={value || ''}
        onChange={handleInputChange}
        onKeyPress={handleKeyPress}
        placeholder={placeholder}
        aria-label={ariaLabel}
        status={error ? 'error' : undefined}
        name={name}
        className="text-field"
        min={1}
      />
      <SaveButton disabled={isDisabled} onClick={onSave}>
        {isSaved ? 'Editar' : 'Guardar'}
      </SaveButton>
      {error && <ErrorMessage>{error}</ErrorMessage>}
    </InputWrapper>
  )
}

export default memo(CustomizableInput)
